import { useTranslation } from 'react-i18next';

function RedirectLoader() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'column wrap',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 64px)',
      }}
    >
      <p>{t('common.loading')}...</p>
    </div>
  );
}

export default RedirectLoader;
